/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */

/* eslint-disable guard-for-in */
export function capitalize(str: any) {
  if (str) {
    return str.replace(
      /([^\W_]+[^\s-]*) */g,
      (txt: any) => txt.charAt(0)
        .toUpperCase() + txt.substr(1)
        .toLowerCase(),
    );
  }
  return str;
}
